<template>
  <el-dialog v-model="visible" :title="t('message.rtu.groupEditTitle')" width="560px">
    <p class="hint">{{ t('message.rtu.groupEditHint') }}</p>
    <el-table :data="rows" size="small" max-height="360">
      <el-table-column :label="t('message.rtu.fleetName')" min-width="150">
        <template #default="{ row }">{{ row.name }}</template>
      </el-table-column>
      <el-table-column :label="t('message.rtu.groupCol')" width="120">
        <template #default="{ row }">
          <el-input-number v-model="row.group" :min="0" :max="99" size="small" controls-position="right" style="width: 90px" />
        </template>
      </el-table-column>
      <el-table-column :label="t('message.rtu.offsetCol')" width="130">
        <template #default="{ row }">
          <el-input-number v-model="row.offset" :min="-20" :max="20" :step="0.5" size="small" controls-position="right" style="width: 100px" />
        </template>
      </el-table-column>
    </el-table>
    <p class="local-note">{{ t('message.rtu.groupLocalNote') }}</p>
    <template #footer>
      <el-button @click="resetDefaults">{{ t('message.rtu.groupReset') }}</el-button>
      <span style="flex:1" />
      <el-button @click="visible = false">{{ t('message.rtu.cancel') }}</el-button>
      <el-button type="primary" @click="save">{{ t('message.rtu.apply') }}</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, defineExpose, defineEmits } from 'vue';
import { useI18n } from 'vue-i18n';
import { ElMessage } from 'element-plus';
import { getGroupConfig, getOverride, saveOverride, clearOverride } from '@/services/rtuGroups';

const { t } = useI18n();
const emit = defineEmits(['saved']);
const visible = ref(false);
const rows = ref([]);

async function openWith(units) {
  const cfg = await getGroupConfig();
  rows.value = units.map((u) => ({
    unitId: u.unitId,
    name: u.name,
    group: cfg[u.unitId]?.group || 0,
    offset: cfg[u.unitId]?.offset || 0,
  }));
  visible.value = true;
}

function save() {
  // 仅把与当前生效值不同的写进本地覆盖（保持文件默认可见）
  const over = getOverride();
  rows.value.forEach((r) => {
    over[r.unitId] = { group: Number(r.group) || 0, offset: Number(r.offset) || 0 };
  });
  saveOverride(over);
  ElMessage.success(t('message.rtu.groupSaved'));
  visible.value = false;
  emit('saved');
}

function resetDefaults() {
  clearOverride();
  ElMessage.success(t('message.rtu.groupResetDone'));
  visible.value = false;
  emit('saved');
}

defineExpose({ openWith });
</script>

<style scoped>
.hint { margin: 0 0 10px; font-size: 13px; color: var(--el-text-color-regular); }
.local-note { margin: 10px 0 0; font-size: 11.5px; color: var(--el-text-color-secondary); }
:deep(.el-dialog__footer) { display: flex; align-items: center; }
</style>
